import React, {useState} from "react"
import {useHistory, useLocation, useParams} from "react-router-dom"
import {createQueryFn, useSolv} from "./components/SolvProvider"
import {useIntlEx} from "./components/IntlUtils"
import Turnstile, {useTurnstile} from "react-turnstile"
import {ActionButton, FormGroup, FormGroups, MainContainer, useAlert} from "./components/FormComps"
import {PageDialog, PageDialogContainer, PageDialogMainPanel} from "./components/PageDialog"
import {isBlankString} from "./components/StringUtils"
import {PageDialogFooter, PageDialogHeader, PageDialogSider} from "./components/PageDialogComps";
import {useQuery} from "react-query";
import getLogger from "./components/Logging.js"
import './App.css'

const log = getLogger("Signup")

export default function SignupRequestAppeal(props) {

  const {env, api, setBusy, setFatal} = useSolv()
  const {intl} = useIntlEx()

  const params = useParams()
  const location = useLocation()
  const history = useHistory()

  const turnstile = useTurnstile()

  const queryParams = new URLSearchParams(location.search)

  const [alert, setAlert] = useAlert()

  const [step, setStep] = useState("PREVERIFICATION")
  const [turnstileVerified, setTurnstileVerified] = useState(false)
  const [appealMessage, setAppealMessage] = useState(null)
  const [country, setCountry] = useState(null)

  const {data: signupRequest, isLoading: signupRequestLoading} = useQuery({
    queryFn: createQueryFn(api.getSignupRequest, params.signupRequestId),
    queryKey: ["signupRequest", params.signupRequestId],
    onError: (error) => handleError(error),
    enabled: !!params.signupRequestId
  })

  function handleTurnstileSuccess(token) {
    setTurnstileVerified(true)
    setStep("FORM")
  }

  function handleAppealMessageChange(e) {
    setAppealMessage(e.target.value)
  }

  async function handleSubmitClick(e) {

  }

  function handleError(error) {
    log.debug("handleError: error=", error)
    if (error && error.code) {
      // log.debug("handleError: code=", error.code)
      const code = error.code
      switch (code) {
        case "UNKNOWN_SIGNUP_CODE":
        case "INVALID_SIGNUP_CODE":
        case "INVALID_REFERRAL_CODE":
        case "ILLEGAL_REFERRAL":
        case "UNAUTHORIZED":
        case "NOT_FOUND":
          setAlert({type: "error", text: intl.msg("signup_error_invalid_signup_code")})
          break
        case "UNKNOWN_INVITER":
        case "INVALID_INVITER":
          setAlert({type: "error", text: intl.msg("signup_error_invalid_inviter")})
          break
        case "INVALID_INVITEE":
          setAlert({type: "error", text: intl.msg("signup_error_invalid_invitee")})
          break
        case "ALREADY_SIGNED_UP":
          setAlert({type: "error", text: intl.msg("signup_error_already_signed_up")})
          break
        case "DUPLICATE_KEY":
        case "DUPLICATE_USER":
        case "DUPLICATE_INVITEE_USER":
          setAlert({type: "error", text: intl.msg("signup_error_duplicate_user", {emailAddress: error.details?.emailAddress || ""})})
          break
        case "DUPLICATE_INVITEE_TENANT":
          setAlert({type: "error", text: intl.msg("signup_error_duplicate_tenant", {tenantName: error.details?.tenantName || ""})})
          break
        case "BANNED_INVITER":
        case "BANNED_USER":
        case "BANNED_REMOTE_ADDRESS":
          setAlert({type: "error", text: intl.msg("error_banned_user")})
          break
        case "BANNED_EMAIL_ADDRESS":
          setAlert({type: "error", text: intl.msg("error_banned_email_address")})
          break
        case "INVALID_EMAIL_ADDRESS":
          setAlert({type: "error", text: intl.msg("error_invalid_email_address")})
          break
        case "INVALID_RECAPTCHA":
          setAlert({type: "error", text: intl.msg("error_invalid_recaptcha")})
          break
        case "INVALID_MAGIC_LINK":
          setAlert({type: "error", text: intl.msg("error_invalid_magic_link")})
          break
        case "DUPLICATE_MAGIC_LINK":
          setAlert({type: "error", text: intl.msg("error_duplicate_magic_link")})
          break
        case "ONBOARDING":
          // doCompleteOnboarding()
          break
        case "UNAVAILABLE":
          window.location = "/unavailable"
          break
        default:
          setAlert({type: "error", text: intl.msg("error_failed")})
      }
    }
    else {
      setAlert({type: "error", text: intl.msg("error_failed")})
    }
  }

  return (
    <MainContainer>
      <PageDialogContainer>
        <PageDialog header={PageDialogHeader} sider={PageDialogSider} footer={PageDialogFooter} size="md" align="center">
          {
            ["PREVERIFICATION"].includes(step) ? (

                <PageDialogMainPanel>
                  <div className="d-flex flex-row align-items-center" style={{minHeight: "300px"}}>
                    <Turnstile
                      sitekey={env.turnstileSiteKey}
                      theme="auto"
                      onSuccess={handleTurnstileSuccess}
                    />
                  </div>
                </PageDialogMainPanel>

            ) : ["FORM"].includes(step) ? (

              <PageDialogMainPanel title={intl.msg("signup_request_appeal_title", {brand: env.displayName})} alert={alert}>

                <div className="mb-3">
                  {intl.msg("signup_request_appeal_text", {brand: env.displayName})}
                </div>

                <FormGroups>

                  <FormGroup>
                    <FormGroup.Label text={intl.msg(`signup_request_appeal_text_1`, {applicant: `${signupRequest?.fullName} <${signupRequest?.emailAddress}>`})}/>
                    <FormGroup.Controls>
                      {signupRequest?.etc?.resolve?.message || ""}
                    </FormGroup.Controls>
                  </FormGroup>

                  <FormGroup>
                    <FormGroup.Label text={intl.msg(`signup_request_appeal_text_2`)}/>
                    <FormGroup.Controls>
                      <textarea id="inp_message" className="form-control" style={{width: "100%"}} type="text" value={appealMessage} onChange={handleAppealMessageChange}/>
                    </FormGroup.Controls>
                  </FormGroup>

                </FormGroups>

                <div className="mt-3">
                  <ActionButton name={"submit"} flavor="primary" disabled={isBlankString(appealMessage) || !country} onClick={handleSubmitClick}/>
                </div>

              </PageDialogMainPanel>

            ) : (
              <></>
            )

          }

        </PageDialog>
      </PageDialogContainer>
    </MainContainer>
  )
}

